import mainSlice from "./reducers/SidebarReducer/SidebarReducer";
import { configureStore } from "@reduxjs/toolkit";
import loginSlice from "./reducers/LoginReducer/LoginReducer";
import RegFormSlice from "./reducers/RegistrationReducer/Form"
import labFormSlice from "./reducers/LaborantReducer/Form";
import LaborantSlice from "./reducers/LaborantReducer/LaborantReducer";
import DocFormSlice from "./reducers/DoctorReducer/Form";
import DoctorSlice from "./reducers/DoctorReducer/DoctorReducer";
import WorkersSlice from "./reducers/PatientReducer/PatientReducer";
import RegistrationSlice from "./reducers/RegistrationReducer/RegistrationReducer";
import typeOfEnterSlice from "./reducers/LoginReducer/Form";
import RegistrationScanSlice from "./reducers/ScanReducer/RegistrationScanReducer";
import ResultsSlice from "./reducers/ResultsReducer/ResultsReducer";
import ReferralsSlice from "./reducers/ReferralsReducer/ReferralsReducer";
import PatientCardSlice from "./reducers/PatientCardReducer/PatientCardReducer";
import ContractSlice from "./reducers/ContractReducer/ContractReducer";

const store = configureStore({
    reducer: {
        main: mainSlice.reducer,
        login: loginSlice.reducer,
        workers: WorkersSlice.reducer,
        referrals: ReferralsSlice.reducer,
        regForm: RegFormSlice.reducer,
        regFormOutput: RegistrationSlice.reducer,
        typeOfEnterSlice: typeOfEnterSlice.reducer,
        labForm: labFormSlice.reducer,
        labFormOutput: LaborantSlice.reducer,
        docForm: DocFormSlice.reducer,
        docFormOutput: DoctorSlice.reducer,
        RegScan: RegistrationScanSlice.reducer,
        ResultsSlice: ResultsSlice.reducer,
        patientCard: PatientCardSlice.reducer,
        ContractSlice: ContractSlice.reducer,
    },
});

export default store;